import React from 'react';
import ActivityLoader from '../Common/ActivityLoader';
import Pagination from '../Common/Pagination';
import { formatDate } from '../../util/araknerdlib';
import { useNavigate } from 'react-router-dom';

const formatCurrency = (n) => new Intl.NumberFormat().format(n || 0);

const VoucherTable = ({ data, selected, setSelected, onRowClick, metaData, setCurrentPage, onRevoke, ref }) => {
  const rows = Array.isArray(data) ? data : [];
  const allChecked = rows.length > 0 && selected?.length === rows.length;
  const navigation = useNavigate();


  const toggleAll = () =>
    setSelected((prev) => (prev.length === rows.length ? [] : rows.map((r) => r.id)));

  const toggleRow = (id) =>
    setSelected((prev) => (prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]));

  const badge = (status) => {
    const map = {
      unused: 'primary',
      used: 'success',
      expired: 'secondary',
      revoked: 'dark',
      refunded: 'warning',
    };
    return map[status] || 'light';
  };

  const handleVoucherClick = (voucher) => {
    navigation(`/voucher-usage?v=${voucher}`);
  };

  return (
    <div className="card">
      <div className="card-header d-flex align-items-center">
        <div>
          {/* <input type="checkbox" checked={!!allChecked} onChange={toggleAll} />{' '}
          <span className="ml-2 text-muted small">
            {selected?.length ? `${selected.length} selected` : 'Select all'}
          </span> */}
        </div>
        <div className="ml-auto">
          <button
            className="btn btn-sm btn-outline-danger mr-2"
            disabled={!selected?.length}
            onClick={onRevoke}
          >
            <i className="fas fa-ban mr-1" />
            Revoke
          </button>
        </div>
      </div>

      {/* Horizontal + vertical scroll */}
      <div
        className="table-responsive"
        style={{ overflowX: 'auto', overflowY: 'auto', maxHeight: 400 }}
        ref={ref}
      >
        <table className="table table-hover mb-0" style={{ minWidth: 1200 }}>
          <thead className="thead-light">
            <tr>
              <th style={{ width: 40 }} />
              <th>Voucher Code</th>
              <th>Plan</th>
              <th>Source</th>
              <th>MSISDN</th>
              <th>Status</th>
              <th>Created At</th>
              <th>First Used</th>
              <th>Usage</th>
              <th>Expires</th>
              <th>Price</th>
              <th>MAC</th>
              <th>IP</th>
              <th>Last Used</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.id} onClick={() => onRowClick?.(r)} style={{ cursor: 'pointer' }}>
                <td onClick={(e) => e.stopPropagation()}>
                  <input
                    type="checkbox"
                    checked={selected?.includes(r.code)}
                    onChange={() => toggleRow(r.code)}
                  />
                </td>
                <td style={{ whiteSpace: 'nowrap', fontWeight: 'bold' }}>
                  <span className='link' onClick={()=>handleVoucherClick(r.code)}>{r.code}</span>
                </td>
                <td>{r.plan_name || r.plan_id || '—'}</td>
                <td>{r.source === 'momo' ? 'Mobile Money' : 'Manual'}</td>
                <td>{r.msisdn || r.created_by_name || '—'}</td>
                <td>
                  <span className={`badge badge-${badge(r.status)}`}>{r.status}</span>
                </td>
                <td>{formatDate(r.created_at)}</td>
                <td>{r.first_used_at ? formatDate(r.first_used_at) : '—'}</td>
                <td>{r.usage_count ?? 0}</td>
                <td>{r.expires_at ? formatDate(r.expires_at) : '—'}</td>
                <td>
                  {formatCurrency(r.amount)}
                </td>
                <td>{r.mac_address || '—'}</td>
                <td>{r.ip_address || '—'}</td>
                <td>{r.last_used_at ? formatDate(r.last_used_at) : '—'}</td>
              </tr>
            ))}

            {data === '404' && (
              <tr>
                <td colSpan={14} className="text-center text-muted py-4">
                  No vouchers found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {metaData && (
        <div className="card-footer d-flex justify-content-between align-items-center">
          <div className="text-muted small">Showing {metaData.total} voucher(s)</div>
          <Pagination metaData={metaData} onPageChange={(page) => setCurrentPage(page)} />
        </div>
      )}

      {!data && <ActivityLoader />}
    </div>
  );
};

export default VoucherTable;
